import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../auth.service';
import { User } from '../user';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup = this.fb.group({
    'email': ['', [Validators.required, Validators.email]],
    'password': ['', [Validators.required, Validators.minLength(6)]],
  });

  loading: boolean = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private authService: AuthService
  ) { }

  ngOnInit(): void { }

  private loginOkNotification(u: User) {
    this.snackBar.open(`Logged in successfully. Welcome ${u.firstname}!`, 'OK', { duration: 2000 });
  }

  private loginErrorNotification(err) {
    this.snackBar.open(err, 'OK', { duration: 2000 });
  }

  onSubmit() {
    this.loading = true;
    this.disabledForm();
    this.authService
      .login(this.loginForm.value.email, this.loginForm.value.password)
      .subscribe(
        (u) => {
          this.loginOkNotification(u);
          this.router.navigateByUrl('/');
          this.loading = false;
          this.enableForm();
        },
        (err) => {
          this.loginErrorNotification(err);
          this.loading = false;
          this.enableForm();
        }
      )
  }

  disabledForm() {
    this.loginForm.controls['email'].disable();
    this.loginForm.controls['password'].disable();
  }

  enableForm() {
    this.loginForm.controls['email'].enable();
    this.loginForm.controls['password'].enable();
  }

  loginGoogle() {
    this.loading = true;
    this.disabledForm();
    this.authService.loginGoogle()
      .subscribe(
        (u) => {
          this.loginOkNotification(u);
          this.router.navigateByUrl('/');
          this.loading = false;
          this.enableForm();
        },
        (err) => {
          this.loginErrorNotification(err);
          this.loading = false;
          this.enableForm();
        }
      )
  }
}
